/* global swal */
import './style.less';
import template from './template.html';
import 'assets/inspinia/plugins/metisMenu/jquery.metisMenu';
import { get } from 'lodash';

export default function($timeout) {
  'ngInject';
  return {
    restrict: 'E',
    template: template,
    link: function(vm, $element) {
      $timeout(function() {
        $element.metisMenu();
      });
    },
    controllerAs: 'topNavCtrl',
    controller: function($state, $stateParams, $log, $transitions, $window, ProfileClass, AuthClass, VendorClass) {
      'ngInject';

      const vm = this;
      vm.$onChanges = activate;

      vm.firmResponse = false;
      vm.breadcrumbs = [];
      vm.imgWhiteProlaeraTextLogo = '//d4znxc3tx8unj.cloudfront.net/whiteProlaeraTextLogo.png';
      vm.profileImg = '//d4znxc3tx8unj.cloudfront.net/profile_small.jpg';
      vm.helpViewable = false;

      const lg = 'https://assets.prolaera.com/prolaeraLogo_fullText.png';
      const sm = 'https://assets.prolaera.com/prolaeraLogo.png';

      vm.loggedIn = ProfileClass.loggedIn;

      ProfileClass.updateAlerts();

      let company_id = 1;

      if (vm.breadcrumbs.length === 0) {
        vm.breadcrumbs.push({
          stateName: $state.current.stateName,
          stateUrl: $state.current.name,
          params: $stateParams,
          path: `${$state.current.name}(${JSON.stringify($stateParams)})`
        });
      }

      if (vm.currentAddress === undefined || null) {
        vm.currentAddress = $state.current.name;
      }

      vm.viewHelp = () => {
        vm.helpViewable = !vm.helpViewable;
      };

      vm.openLogin = () => {
        AuthClass.authenticationPopup({ company_id });
      };

      $transitions.onSuccess({}, function(trans) {
        vm.loggedIn = ProfileClass.loggedIn;

        const currentPath = trans.to();
        const currentPathParams = trans.params();
        const fromPath = trans.from();

        if (fromPath.name !== currentPath.name) {
          ProfileClass.updateAlerts();
        }

        vm.currentAddress = currentPath.stateName;
        if (vm.breadcrumbs[vm.breadcrumbs.length - 1].stateName !== currentPath.stateName) {
          vm.breadcrumbs.push({
            stateName: currentPath.stateName,
            stateUrl: currentPath.name,
            path: `${currentPath.name}(${JSON.stringify(currentPathParams)})`
          });
          if (vm.breadcrumbs.length > 3) {
            vm.breadcrumbs.shift();
          }
        }

        setVendorInfo(currentPath, currentPathParams);
      });

      function setVendorInfo({ name }, { vendor_id }) {
        if (!name.includes('vendor') || !vendor_id) {
          vm.largeLogo = lg;
          vm.smallLogo = sm;
          vm.vendorPath = false;
          company_id = 1;
          return;
        }

        vm.vendorPath = true;

        VendorClass.loadVendors()
          .then(({ obj }) => {
            const vendor = get(obj, `${vendor_id}`, { logo: { lg, sm } });

            vm.largeLogo = vendor.logo.lg;
            vm.smallLogo = vendor.logo.sm;

            company_id = VendorClass.convertUser(vendor_id);
          })
          .catch(error => {
            vm.largeLogo = lg;
            vm.smallLogo = sm;
            throw error;
          });
      }

      function activate() {
        vm.userProfile = ProfileClass.userProfile;
        vm.alerts = ProfileClass.alerts;

        setVendorInfo($state.current, $stateParams);
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/topnav/index.js